<template>
  <ul class="list-group" :class="[variant, size]">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  name: 'list-group',
  props: ['type', 'variant', 'size']
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
.list-group {
  margin-bottom: 10px;
}
.list-group.-normal {
  color: $black;
  padding-left: 20px;
  >.list-item.-normal {
    list-style-type: square;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 5px;
    @include mq-up(md) {
      font-size: 16px;
      line-height: 24px;
    }
    >.list-group.-normal {
      padding-left: 20px;
      >.list-item.-normal {
        list-style-type: square;
        font-size: 12px;
        line-height: 18px;
        margin-top: 5px;
        margin-bottom: 5px;
        @include mq-up(md) {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }
}
.list-group.-note {
  color: $gray;
  margin-left: 20px;
  >.list-item.-note {
    list-style-type: none;
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 5px;
    &:before {
      content: '※';
      margin-left: -20px;
      margin-right: 10px;
    }
    @include mq-up(md) {
      font-size: 14px;
      line-height: 24px;
    }
    >.list-group.-note {
      >.list-item.-note {
        list-style-type: none;
        font-size: 12px;
        line-height: 18px;
        margin-top: 5px;
        margin-bottom: 5px;
        &:before {
          content: '※';
          margin-left: -16px;
          margin-right: 8px;
        }
        @include mq-up(md) {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }
}

.list-group.-twocolumn + .list-group.-twocolumn {
  @include mq-down(md) {
    > .list-item {
      &:first-child {
        border-top: none;
      }
    }
    margin-top: -10px;
  }
}
//よくある質問カード
.card-box.-faq {
  >.card-body {
    >.list-group {
      margin-bottom: 20px;
      @include mq-up() {
        @include flex(flex,space-between,stretch,row,wrap);
        margin-bottom: 40px;
      }
      >.list-item {
        @include flex(flex,stretch,center,row,wrap);
        a {
          background-image: url('../../assets/images/icons/Q.svg');
        }
        @include mq-down() {
          width: 100%;
        }
        @include mq-up(){
          width: calc(50% - 20px);
          &:nth-of-type(2){
            border-top: $secondary dotted 1px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/list/ListGroup.vue